(() => {
  const sectionSelector = '[data-t700-section]';
  const globoSelectors = [
    '.gpo-container',
    '.gpo-hidden-inputs',
    '[class^="gpo-"]',
    '[class*=" gpo-"]',
    'input[name="properties[_has_gpo]"]',
    'input[name^="properties[_gpo"]',
    'input[name="color"]',
    'input[name="product-id"]',
    'input[name="section-id"]'
  ].join(',');

  const initRoot = (root) => {
    if (!root || root.dataset.t700Initialized === 'true') return;
    root.dataset.t700Initialized = 'true';

    const purgeGloboOptions = () => {
      root.querySelectorAll(globoSelectors).forEach((node) => node.remove());
    };

    const mainImage = root.querySelector('.besitsol-t700-pdp__main-image');
    const thumbButtons = Array.from(root.querySelectorAll('[data-t700-thumb]'));

    root.querySelectorAll('.besitsol-t700-pdp__story--text-only').forEach((story) => {
      if (story.querySelector('.besitsol-t700-pdp__story-media img')) {
        story.classList.remove('besitsol-t700-pdp__story--text-only');
      }
    });

    if (mainImage && thumbButtons.length) {
      let activeIndex = Math.max(0, thumbButtons.findIndex((button) => button.classList.contains('is-active')));

      const activate = (index) => {
        const safeIndex = (index + thumbButtons.length) % thumbButtons.length;
        const button = thumbButtons[safeIndex];
        const fullUrl = button.dataset.t700Full;
        if (!fullUrl) return;

        mainImage.src = fullUrl;
        if (button.dataset.t700Srcset) mainImage.srcset = button.dataset.t700Srcset;
        if (button.dataset.t700Sizes) mainImage.sizes = button.dataset.t700Sizes;
        mainImage.alt = button.dataset.t700Alt || '';
        thumbButtons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });
        activeIndex = safeIndex;
      };

      thumbButtons.forEach((button, index) => {
        button.addEventListener('click', () => activate(index));
      });
      root.querySelector('[data-t700-prev]')?.addEventListener('click', () => activate(activeIndex - 1));
      root.querySelector('[data-t700-next]')?.addEventListener('click', () => activate(activeIndex + 1));
    }

    const variantSelect = root.querySelector('[data-t700-variant-select]');
    if (variantSelect) {
      const price = root.querySelector('[data-t700-price]');
      const submit = root.querySelector('[data-t700-submit]');
      const submitLabel = root.querySelector('[data-t700-submit-label]');
      const syncVariant = () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        if (!option) return;
        const available = option.dataset.available === 'true';
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (submit) submit.disabled = !available;
        if (submitLabel && submit) {
          submitLabel.textContent = available
            ? submit.dataset.availableLabel
            : submit.dataset.unavailableLabel;
        }
      };
      variantSelect.addEventListener('change', syncVariant);
      syncVariant();
    }

    root.querySelectorAll('[data-t700-file-input]').forEach((input) => {
      const nameTarget = input.closest('.besitsol-t700-pdp__file-drop')?.querySelector('[data-t700-file-name]');
      if (!nameTarget) return;
      input.addEventListener('change', () => {
        const fileName = input.files?.[0]?.name;
        nameTarget.textContent = fileName || 'No file selected';
      });
    });

    purgeGloboOptions();

    const form = root.querySelector('.besitsol-t700-pdp__form');
    if (form) {
      form.addEventListener('submit', purgeGloboOptions, true);
    }

    const observer = new MutationObserver(purgeGloboOptions);
    observer.observe(root, { childList: true, subtree: true });
  };

  const init = (scope = document) => {
    const roots = scope.matches?.(sectionSelector)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(sectionSelector) || []);
    roots.forEach(initRoot);
  };

  if (window.BesitsolT700Pdp?.version === 1) {
    window.BesitsolT700Pdp.init(document);
    return;
  }

  window.BesitsolT700Pdp = { init, version: 1 };
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
